<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div v-else>
      <h1 class="text-center text-info">List of Students Enrolled</h1>
      <InstitutionUserTable v-if="tableView" :users="listOfUsersEnrolled" />
      <div v-else>
        <div v-if="editType == 'Bulk_Profile'">
          <profile-update @cancelProfile="cancelProfile" :sortByOrder="sortByOrder"
            :institutionUserIds="institutionUsers" :groupInfo="groupInfo" />
        </div>
        <div v-if="editType == 'Profile'">
          <individual-profile-update @cancelProfile="cancelProfile" :sortByOrder="sortByOrder"
            :institutionUserIds="institutionUsers" :groupInfo="groupInfo" />
        </div>
        <div v-if="editType == 'ViewProfile'">
          <view-profile @cancelProfile="cancelProfile" :sortByOrder="sortByOrder"
            :institutionUserId="selectedInstitutionUserId" :groupInfo="groupInfo" />
        </div>
        <div v-else-if="editType == 'RollNumber'">
          <roll-number-update @rollNumbersUpdated="rollNumbersUpdated" :listOfUsersEnrolled="listOfUsersEnrolled"
            :selectedSubgroupUsers="selectedSubgroupUsers" :groupInfo="groupInfo" />
        </div>
        <div v-else class="subgroupUserList px-2">
          <!-- Action Buttons -->
          <div class="editOptions d-flex align-items-center flex-wrap py-2"
            style="border: 2px solid #eeeeeb; border-left: none; border-right: none;"
            v-if="listOfUsersEnrolled.length > 0 && editType == 'Users'">
            <b-form-checkbox size="lg" v-model="allUsersSelected" @change="toggleAll" :indeterminate="indeterminate">
              {{ allUsersSelected ? "Un-select All" : "Select All" }}
            </b-form-checkbox>

            <b-button variant="primary" size="sm" @click="subgroupInstitutionProfileUpdate()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              Profile Edit <i class="fas fa-edit text-white ml-2"></i>
            </b-button>

            <b-button variant="primary" size="sm" @click="subgroupInstitutionProfileBulkUpdate()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              Profile Bulk Edit <i class="fas fa-edit text-white ml-2"></i>
            </b-button>

            <b-button variant="primary" size="sm" @click="rollNumberUpdate()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              Roll Number <i class="fas fa-edit text-white ml-2"></i>
            </b-button>

            <b-button variant="primary" size="sm" @click="parentInvitation()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              Send Invitation Email to Parents
            </b-button>

            <b-button variant="success" size="sm" class="ml-2" @click="updateStudentsEnrollStatus('active')"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              {{ enableEnrollStatusBtn ? "Activate" : "working..." }}
            </b-button>

            <b-button variant="danger" size="sm" class="ml-2" @click="updateStudentsEnrollStatus('blocked')"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled">
              {{ enableEnrollStatusBtn ? "Deactivate" : "working..." }}
            </b-button>

            <b-button variant="danger" size="sm" v-html="deleteBtn.text" @click="prepareSubgroupStudentForDelete()"
              :disabled="selectedSubgroupUsers.length == 0 || deleteBtn.disabled" />

            <b-button variant="success" size="sm"
              :disabled="!enableFeeAlertButtons || selectedSubgroupUsers.length == 0"
              @click="$bvModal.show('feeReminder-confirm')">
              {{ enableFeeAlertButtons ? "Send fee reminder" : "Please wait..." }}
            </b-button>

            <b-button variant="success" size="sm" :disabled="exportCsvBtn.disabled || listOfUsersEnrolled.length == 0"
              @click="exportToExcel('xlsx')">
              {{ exportCsvBtn.text }}
            </b-button>
            <div>
              <b-form-select class="ml-3 mt-2" size="sm" v-model="selectedSort">
                <option value="">-- Sort Options --</option>
                <option value="name">Sort by Name</option>
                <option value="invitation">Sort by Invite</option>
              </b-form-select>
            </div>


            <!-- Fee Reminder Modal -->
            <b-modal id="feeReminder-confirm" no-close-on-backdrop no-close-on-keyboard hide-footer hide-header
              centered>
              <h4>Send fee Reminder SMS</h4>
              <p class="my-4">
                WARNING: You are going to send fee due SMS message to all parents
                of selected students.
              </p>
              <b-row>
                <b-col>
                  <b-button variant="danger" size="sm" @click="$bvModal.hide('feeReminder-confirm')">Cancel</b-button>
                </b-col>
                <b-col class="text-right">
                  <b-button variant="success" size="sm" @click="sentFeeRemainder">Send</b-button>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col>Balance SMS Count: {{ smsCount }}</b-col>
              </b-row>
            </b-modal>
          </div>

          <!-- Table -->
         
          <div class="enrolledUsersTableView mt-2" v-if="editType == 'Users'">
            <div class="table-responsive rounded">
            <table class="table table-striped table-bordered table-sm"
              style="font-size: 5px; font-weight: 500; width: 100%;" ref="subgroupUsers">
              <thead class="thead-dark">
                <tr>
                  <th class="sticky-col first-col"></th>
                  <th class="sticky-col second-col">Roll No.</th>
                  <th class="sticky-col third-col">Name</th>
                  <th>Sign-up Status</th>
                  <th>Admission No.</th>
                  <th>Registration No.</th>
                  <th>Gender</th>
                  <th>Phone No.</th>
                  <th>Email</th>
                  <th>Guardian Name</th>
                  <th>Guardian Phone</th>
                  <th>Guardian Email</th>
                  <th>Aadhaar card no</th>
                  <th>Date of Joining</th>
                  <th>Entrance Rank</th>
                  <th>Category Of Admission</th>
                  <th>Religion & Caste</th>
                  <th>Blood Group</th>
                  <th>Reservation Category</th>
                  <th>Communication Address</th>
                  <th>Permanent Address</th>
                  <th>Institution Last Attended(HSE)</th>
                  <th>Code of Institution last attended</th>
                  <th>District of institution last attended</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="listOfUsersEnrolled.length === 0" class="text-danger">
                  <td colspan="100">No Students Found!</td>
                </tr>
                <tr v-else v-for="(student, studentIndex) in listOfUsersEnrolled" :key="studentIndex">
                  <td class="sticky-col first-col">
                    <b-form-checkbox size="sm" v-model="selectedSubgroupUsers" :value="student.id" />
                  </td>
                  <td class="sticky-col second-col">{{ student.roll_number || "RN" }}</td>
                  <td class="sticky-col third-col">
                    <span class="btn p-0 m-0 text-info font-weight-bolder text-capitalize" style="cursor: pointer;"
                      @click="viewProfile(student.institution_user_id)">
                      {{ student.first_name || "" }} {{ student.last_name || "" }}
                    </span>
                  </td>
                  <td>
                    <b-badge v-if="!student.user_id" pill variant="warning">Pending</b-badge>
                    <b-badge v-else pill variant="success">Completed</b-badge>
                    <b-badge v-if="student.enroll_status !== 'active'" variant="danger"
                      class="ml-2">Deactivated</b-badge>
                    <b-button v-if="!student.user_id" variant="info" size="sm" class="m-1 p-1"
                      @click="resendInvitation(student.institution_user_id)">
                      Resend
                    </b-button>
                  </td>
                  <td class="text-uppercase">{{ student.admission_no || "" }}</td>
                  <td class="text-uppercase">{{ student.register_no || "" }}</td>
                  <td class="text-capitalize">{{ student.gender || "-" }}</td>
                  <td>{{ student.mobile || "" }}</td>
                  <td>{{ student.email || "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].name : "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].phone_number : "" }}</td>
                  <td>{{ (student.guardians && student.guardians[0]) ? student.guardians[0].email : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.aadhaar_card_no : "" }}</td>
                  <td>{{ (student.profile && student.profile.date_of_joining) ?
                    formatDate(student.profile.date_of_joining) : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.entrance_rank : "" }}</td>
                  <td>{{ (student.profile && student.profile.category_of_admission) ?
                    student.profile.category_of_admission.toUpperCase() : "" }}</td>
                  <td>
                    {{ (student.profile && student.profile.religion) ? student.profile.religion.toUpperCase() : "" }} -
                    {{ (student.profile && student.profile.caste) ? student.profile.caste.toUpperCase() : "" }}
                  </td>
                  <td>{{ (student.profile && student.profile.blood_group) ? student.profile.blood_group.toUpperCase() :
                    "" }}</td>
                  <td>{{ (student.profile && student.profile.reservation_category) ?
                    student.profile.reservation_category.toUpperCase() : "" }}</td>

                  <!-- Communication Address -->
                  <td>
                    {{
                      (student.profile ? [
                        student.profile.house_name_communication_address,
                        student.profile.town_communication_address,
                        student.profile.pincode_communication_address,
                        student.profile.district_communication_address,
                        student.profile.state_communication_address,
                        student.profile.country_communication_address
                      ].filter(function (a) { return a; }).join(', ') : "")
                    }}
                  </td>

                  <!-- Permanent Address -->
                  <td>
                    {{
                      (student.profile ? [
                        student.profile.house_name_permanent_address,
                        student.profile.town_permanent_address,
                        student.profile.pincode_permanent_address,
                        student.profile.district_permanent_address,
                        student.profile.state_permanent_address,
                        student.profile.country_permanent_address
                      ].filter(function (a) { return a; }).join(', ') : "")
                    }}
                  </td>

                  <td>{{ (student.profile) ? student.profile.last_institution : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.code_of_institution_last_attended : "" }}</td>
                  <td>{{ (student.profile) ? student.profile.district_of_institution_last_attended : "" }}</td>
                </tr>
              </tbody>

            </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.enrolledUsersTableView {
  overflow-x: auto;
  width: 100%;
}

.enrolledUsersTableView table {
  white-space: nowrap;
  table-layout: auto;
}

.enrolledUsersTableView th,
.enrolledUsersTableView td {
  padding: 6px 8px;
  font-size: 13px;
  vertical-align: middle;
}

.subgroupUserList .editOptions button,
.subgroupUserList .editOptions .form-control {
  margin: 2px !important;
}
</style>


<script>
import axios from "axios";
import ProfileUpdate from "./ProfileUpdate.vue";
import IndividualProfileUpdate from "./IndividualProfileUpdate.vue";
import RollNumberUpdate from "./RollNumberUpdate.vue";
import ViewProfile from "./ViewProfile.vue";
import XLSX from "xlsx";
import InstitutionUserTable from "../../../institution_users//InstitutionUserTable.vue";

export default {
  props: ["groupInfo"],
  async created() {
    await this.getEnrolledSubgroupUsers();
    this.smsCount = this.$store.getters.getSmsCount.smsBalance;
  },

  components: {
    profileUpdate: ProfileUpdate,
    rollNumberUpdate: RollNumberUpdate,
    InstitutionUserTable,
    IndividualProfileUpdate,
    ViewProfile
  },
  data() {
    return {
      selectedSort: "",
      selectedInstitutionUserId: "",
      institution_users: [],
      institutionUsersProfiles: [],
      institutionuserGuardians: [],
      enableEnrollStatusBtn: true,
      enableFeeAlertButtons: true,
      fetchData: false,
      listOfUsersEnrolled: [],
      selectedSubgroupUsers: [],
      institutionUsers: [],
      allUsersSelected: false,
      indeterminate: false,
      editType: "Users",
      deleteBtn: {
        text: `Remove <i class="fas fa-trash text-white ml-2"></i>`,
        disabled: false,
      },
      tableView: false,
      exportCsvBtn: {
        text: "Export to Excel",
        disabled: false,
      },
      sortByOrder: "",
      smsCount: 0,
    };
  },
  watch: {
    selectedSort(newValue) {
      if (!newValue) return;
      this.sortBy(newValue);
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      return new Date(date).toLocaleDateString('en-GB', options); // en-GB for dd/mm/yyyy
    },
    updateStudentsEnrollStatus(status) {
      this.listOfUsersEnrolled.forEach((user) => {
        if (this.selectedSubgroupUsers.includes(user.id))
          this.institution_users.push(user.pivot.institution_user_id);
      });
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        "/institutionusers/enroll_status";
      axios
        .post(url, {
          institution_users: this.institution_users,
          enroll_status: status,
        })
        .then(() => {
          this.$toast.success("Enroll status updated successfully");
          this.selectedSubgroupUsers = [];
          this.institution_users = [];
          this.getEnrolledSubgroupUsers();
        })
        .catch(() => {
          this.$toast.error("Failed to update enroll status, please try again");
        });
      this.enableEnrollStatusBtn = true;
    },
    async viewProfile(institution_user_id) {
      this.selectedInstitutionUserId = institution_user_id;
      this.editType = 'ViewProfile';

      // console.log("this.groupInfo",this.groupInfo);
      // console.log("institution_user_id",institution_user_id);
      // console.log("this.sortByOrder",this.sortByOrder);
      // // this.institutionUsers = [];
      // // this.institutionUsers.push(institution_user_id);
      // this.$root.subContent.subContentComponent = "ViewProfile";
      // this.$root.subContent.subContentData = {
      //   groupInfo: this.groupInfo,  // Ensure groupInfo is defined elsewhere in your component
      //   institutionUserId: [institution_user_id],
      //   sortByOrder: this.sortByOrder  // Ensure sortByOrder is defined elsewhere in your component
      // };
      // this.$root.subContent.enableMainContent = false;
    },
    async exportToExcel(type, fn, dl) {
      this.exportCsvBtn.text = "Please wait...";
      this.exportCsvBtn.disabled = true;
      var elt = this.$refs.subgroupUsers;
      var wb = await XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      this.exportCsvBtn.text = "Export to Excel";
      this.exportCsvBtn.disabled = false;
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
          wb,
          fn || this.groupInfo.name + "_users." + (type || "xlsx")
        );
    },
    cancelProfile() {
      this.editType = "Users";
      this.selectedSubgroupUsers = [];
      this.allUsersSelected = false;
      this.institutionUsers = [];
      this.getEnrolledSubgroupUsers();
    },
    async subgroupInstitutionProfileBulkUpdate() {
      this.institutionUsers = [];
      await this.listOfUsersEnrolled.forEach((student) => {
        this.selectedSubgroupUsers.forEach((id) => {
          if (student.id == id) {
            this.institutionUsers.push(student.pivot.institution_user_id);
          }
        });
      });
      this.editType = "Bulk_Profile";
    },
    async subgroupInstitutionProfileUpdate() {
      this.institutionUsers = [];
      await this.listOfUsersEnrolled.forEach((student) => {
        this.selectedSubgroupUsers.forEach((id) => {
          if (student.id == id) {
            this.institutionUsers.push(student.pivot.institution_user_id);
          }
        });
      });
      this.editType = "Profile";
    },
    async parentInvitation() {

      const selectedUsers = this.selectedSubgroupUsers
        .map(id => this.listOfUsersEnrolled.find(user => user.id === id))
        .filter(Boolean);
      const usersWithoutEmail = selectedUsers.filter(user =>
        !user.guardians || !user.guardians[0] || !user.guardians[0].email
      );
      if (usersWithoutEmail.length) {
        const names = usersWithoutEmail
          .map(u => `${u.first_name} ${u.last_name}`)
          .join(', ');
        this.$toast.error(`Guardian email not updated for: ${names}`, { top: "top", duration: 10000 });
        return;
      }

      const institutionUserIds = selectedUsers.map(u => u.institution_user_id);

      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/inviteparentusers`;
        const res = await axios.post(url, { institutionUserIds });

        // Handle success message from server
        this.$toast.success(res.data.message || "Invite Successfully.", {
          top: "top",
          duration: 3000
        });

        this.selectedSubgroupUsers = [];
      } catch (error) {
        const message = error.response?.data?.message || "Failed to send invites.";
        this.$toast.error(message, {
          top: "top",
          duration: 4000
        });
      }
    },

    async sentFeeRemainder() {
      this.$bvModal.hide("feeReminder-confirm");
      this.enableFeeAlertButtons = false;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupusers/studentfeeduealert`;
      await this.$axios
        .post(url, {
          usersubgroup: this.groupInfo.id,
          students: this.selectedSubgroupUsers,
        })
        .then(() => {
          this.$toast.success(
            `Fee due alert successfully sent to selected students.`,
            {
              top: "top",
              duration: 3000,
            }
          );
        })
        .catch(() => {
          this.$toast.error(`Failed to sent Fee due alert`, {
            top: "top",
            duration: 6000,
          });
        });

      this.selectedSubgroupUsers = [];
      this.allUsersSelected = false;

      this.enableFeeAlertButtons = true;
    },
    rollNumbersUpdated() {
      this.editType = "Users";
      this.selectedSubgroupUsers = [];
      this.allUsersSelected = false;
      this.getEnrolledSubgroupUsers();
    },
    rollNumberUpdate() {
      this.editType = "RollNumber";
    },
    toggleAll(checked) {
      let subgroupUsers = [];
      this.listOfUsersEnrolled.forEach((user) => {
        subgroupUsers.push(user.id);
      });
      this.selectedSubgroupUsers = checked ? subgroupUsers.slice() : [];
    },

    async sortBy(order) {
      this.sortByOrder = order;
      this.getEnrolledSubgroupUsers();
    },
    async getEnrolledSubgroupUsers() {
      this.fetchData = true;
      let url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupusers/profileindex`;
      let params = {
        usersubgroupId: this.groupInfo.id,
        sortby: this.sortByOrder
      };
      await this.$axios
        .post(url, params)
        .then((response) => {
          this.listOfUsersEnrolled = [];
          this.listOfUsersEnrolled = response.data;
          this.listOfUsersEnrolled = this.listOfUsersEnrolled.filter(
            (students) => {
              return students.pivot.usersubgrouprole_id == 2;
            }
          )
          this.sortedArray();
          this.fetchData = false;
          response;
        })
        .catch((error) => {
          this.fetchData = false;
          error;
        });
    },
    sortedArray() {
      // this.listOfUsersEnrolled.sort(function(a, b) {
      //   return (
      //     a.roll_number - b.roll_number ||
      //     a.first_name.localeCompare(b.first_name)
      //   );
      // });
      return;
    },
    async prepareSubgroupStudentForDelete() {
      this.deleteBtn.text = `Removing <div class="spinner-grow spinner-grow-sm ml-2"></div>`;
      this.deleteBtn.disabled = true;

      for (const student in this.selectedSubgroupUsers) {
        let studentId = this.selectedSubgroupUsers[student];
        const deleteStudent = await this.deleteEnrolledSubgroupStudent(
          studentId,
          student
        );
        if (deleteStudent == "Completed") {
          this.deleteBtn.text = `Remove <i class="fas fa-trash text-white ml-2"></i>`;
          setTimeout(() => {
            this.deleteBtn.disabled = false;
          }, 3000);
          this.$toast.success("All students removed successfully.", {
            position: "top",
            duration: 3000,
          });
          this.selectedSubgroupUsers = [];
          this.allUsersSelected = false;
          this.getEnrolledSubgroupUsers();
        }
        if (!deleteStudent) {
          this.deleteBtn.text = `Remove <i class="fas fa-trash text-white ml-2"></i>`;
          setTimeout(() => {
            this.deleteBtn.disabled = false;
          }, 3000);
          this.$toast.error("Something went wrong!", {
            position: "top",
            duration: 3000,
          });
          return;
        }
      }
    },
    async deleteEnrolledSubgroupStudent(studentId, studentIndex) {
      let userId = this.$store.getters.getAPIKey.deleteSubGroupUser;
      const url = userId.replace("usersubgroup_user_id", studentId);
      let status = null;
      await this.$axios
        .delete(url)
        .then((response) => {
          response;
          if (studentIndex == this.selectedSubgroupUsers.length - 1) {
            status = "Completed";
          } else {
            status = "Deleting";
          }
        })
        .catch((error) => {
          error;
          status = false;
        });
      return status;
    },

    async resendInvitation(InstitutionUserId) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/institutionusers/${InstitutionUserId}/invitation/resent`;
      this.$axios
        .get(url)
        .then(() => {
          this.$toast.success(`Enrollment code sent successfully`, {
            top: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error(`Failed to sent enrollment code`, {
            top: "top",
            duration: 3000,
          });
        });
    },
  },
};
</script>

<style>
.subgroupUserList .editOptions button {
  margin-left: 10px;
}

.subgroupUserList i {
  font-size: 12px !important;
}

/* make table scrollable */
.enrolledUsersTableView {
  overflow-x: auto;
  position: relative;
}

/* sticky columns */
.sticky-col {
  position: sticky;
  background: #fff; /* so it doesn’t overlap with striped bg */
  z-index: 2;
}

.first-col {
  left: 0;
  z-index: 3; /* keep above others */
  min-width: 40px;
}

.second-col {
  left: 40px; /* equal to first-col width */
  min-width: 80px;
}

.third-col {
  left: 120px; /* first + second widths */
  min-width: 150px;
}

/* thead th {
  position: sticky;
  top: 0;
  z-index: 4;
} */

</style>
